module.exports = __webpack_public_path__ + "static/media/23-3.78375731.mp3";